<!-- Adapted from SPlayer 40d9ec6 src/views/Discover/new.vue (AGPL-3.0).
     The existing catalog exposes new albums, not SPlayer's new-songs endpoint. -->
<template>
  <div class="discover-new" :aria-busy="loading">
    <div class="menu">
      <span class="type">新专辑</span>
      <div v-if="platform !== 'tx'" class="area" role="group" aria-label="新专辑地区">
        <SaltButton v-for="item in areas" :key="item.key" :style-type="area === item.key ? 'subtle' : 'plain'" :aria-pressed="area === item.key" :class="{ active: area === item.key }" @click="selectArea(item.key)">{{ item.value }}</SaltButton>
      </div>
    </div>
    <CoverList :items="items" type="album" />
    <FeedStatus :loading="loading" :error="error" :more="more" :count="items.length" empty-text="来源暂未返回新专辑。" @retry="loadFeed(items.length > 0)" @more="loadFeed(true)" />
  </div>
</template>
<script>
import { runtime } from '../../bridge';
import catalogFeed, { pushOnlineQuery } from './catalog-feed';
import CoverList from './CoverList.vue';
import FeedStatus from './FeedStatus.vue';
import SaltButton from '../ui/SaltButton.vue';
const areas = [{ key: 'ALL', value: '全部' }, { key: 'ZH', value: '华语' }, { key: 'EA', value: '欧美' }, { key: 'KR', value: '韩国' }, { key: 'JP', value: '日本' }];
export default {
  name: 'SPlayerDiscoverNew', mixins: [catalogFeed], components: { CoverList, FeedStatus, SaltButton },
  data() { return { catalogSettings: runtime.catalogSettings, areas }; },
  computed: {
    platform() { return this.catalogSettings.platform; },
    area() { return areas.some(item => item.key === this.$route.query.area) ? this.$route.query.area : 'ALL'; },
    feedKey() { return this.platform + ':' + (this.platform === 'tx' ? 'ALL' : this.area); },
  },
  methods: {
    selectArea(area) { pushOnlineQuery(this, { onlineTab: 'new', area }); },
    async fetchFeed(cursor) { const data = await runtime.catalog('albums', undefined, { platform: this.platform, area: this.area, offset: cursor, limit: 50 }); return { items: data.albums, more: data.more, nextCursor: data.nextCursor }; },
  },
};
</script>
<style scoped>
.discover-new { display: flex; flex-direction: column; min-width: 0; }
.menu { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; min-height: 40px; }
.type { font-size:14px; font-weight:500; }
.area { display: flex; flex-wrap: wrap; gap: 5px; }
.area button { color:var(--salt-text,var(--color-text)); }
button.active { color:var(--salt-accent,var(--color-primary)); }
button:focus:not(:focus-visible) { outline: none; }
</style>
